enum Languages {
    VN = "Vietnamese",
    EN = "English",
    KR = "Korean",
    JP = "Japanese",
    CN = "Chinese"
}

export default Languages;